<template>
    <div class="train-home">
        <ui-header :nav-num="3" :user-info="userInfo" :nav="nav" :login-url="loginUrl" :logout-url="logoutUrl"
                   :register-url="registerUrl" :home-url="homeUrl" :ucenter-url="ucenterUrl"></ui-header>
        <div class="train-main">
            <div class="train-tech">
                <div class="train-head" style="margin-bottom:30px;">
                    <div style="float:left;">
                        <div style="font-size: 18px;color: #364983;height:25px;">
                            视频培训-技术面
                        </div>
                        <div style="letter-spacing: 0;float:left; font-size: 20px;color: rgba(57,73,131,0.16);">
                            Technical
                        </div>
                    </div>
                    <div style="float:right;">
                        <div class="morebtn"  v-on:click="techClick">
                        </div>
                    </div>
                </div>
                <div class="tech-main" style="width:100%;overflow:hidden;">
                    <div style="width:520px;height:320px;float:left;background: #D8D8D8;" v-if="bigTechItem.position
                    != 1">
                        <img src="./images/ad.png" style="width:213px;height:70px;display:block;margin:0 auto;
                        margin-top:125px;">
                    </div>
                    <div v-else style="width:520px;height:320px;float:left;position:relative;">
                        <img :src="bigTechItem.attachment" style="cursor:pointer;position:absolute;"
                             v-on:click="clickDetail
                        (bigTechItem.videoUrl)">
                        <div style="position:absolute;width:100%;bottom:0px;height:74px;font-size: 20px;
                        background:rgba(0, 0, 0, 0.38); padding:22px 20px 24px;
                        color: #FFFFFF;overflow: hidden;white-space: nowrap;text-overflow:ellipsis;" v-html="bigTechItem.title">
                        </div>
                    </div>
                    <div v-for="(item, index) in otherTechItem">
                        <div class="smallTech" v-if="(index+2) != item.position " style="background: #D8D8D8;">
                            <img src="./images/ad.png" style="width:142px;height:46px;display:block;margin:0 auto;
                        margin-top:52px;">
                        </div>
                        <div v-else class="smallTechImg">
                            <img :src="item.attachment" v-on:click="clickDetail(item.videoUrl)" >
                            <div v-html="item.title">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="train-fund">
                <div class="train-head" style="margin-bottom:20px;">
                    <div style="float:left;">
                        <div style="font-size: 18px;color: #364983;height:25px;">
                            视频培训-基础面
                        </div>
                        <div style="letter-spacing: 0;float:left; font-size: 20px;color: rgba(57,73,131,0.16);">
                            Fundamental
                        </div>
                    </div>
                    <div style="float:right;">
                        <div class="morebtn"  v-on:click="fundClick">
                        </div>
                    </div>
                </div>
                <div class="fund-main">
                    <div v-for="(item, index) in baseArr" class="fund-item">
                        <div v-if="(index+1) != item.position">
                            <div class="fund-head" style="background:#D8D8D8;padding-top:62px;">
                                <img src="./images/ad.png" style="width:142px;height:46px;margin:0 auto;
                                display:block;">
                            </div>
                        </div>
                        <div v-else>
                            <div class="fund-head"  v-on:click="clickDetail(item.videoUrl)" style="cursor:pointer;">
                                <img :src="item.attachment">
                                <div class="fund-title" v-html="item.title">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="train-text" v-if="firArr.length != 0">
                <div class="train-head" style="margin-bottom:15px;">
                    <div style="float:left;">
                        <div style="font-size: 18px;color: #364983;height:25px;">
                            文字课程
                        </div>
                        <div style="letter-spacing: 0;float:left; font-size: 20px;height:28px;color: rgba(57,73,131,0.16);">
                            Course
                        </div>
                    </div>
                    <div style="float:right;">
                        <div class="pagebtn">
                        </div>
                    </div>
                </div>
                <div class="course-part">
                    <div class="course-item" v-for="(item, index) in firArr">
                        <div class="course-head">
                            <div class="head-short"></div>
                            <img class="head-img" :src="firPng[index]">
                            <div class="head-line"></div>
                        </div>
                        <div class="course-main">
                            <div class="course-title" v-html="item.category">
                            </div>
                            <div class="course-list">
                                <div v-for="(list, kay) in item.article" v-on:click="clickDetail(list.articleUrl)"
                                     v-html="list.title">
                                </div>
                            </div>
                            <div class="more" v-on:click="clickDetail(item.urlMore)">
                                查看更多
                            </div>
                        </div>
                    </div>
                </div>
                <div class="course-part" style="border-bottom:0;margin-top:30px;">
                    <div class="course-item" v-for="(item, index) in secArr">
                        <div class="course-head">
                            <div class="head-short"></div>
                            <img class="head-img" :src="secPng[index]">
                            <div class="head-line"></div>
                        </div>
                        <div class="course-main">
                            <div class="course-title" v-html="item.category">
                            </div>
                            <div class="course-list">
                                <div v-for="(list, kay) in item.article" v-on:click="clickDetail(list.articleUrl)"
                                     v-html="list.title">
                                </div>
                            </div>
                            <div class="more" v-on:click="clickDetail(item.urlMore)">
                                查看更多
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <online-service></online-service>
        <img src="./images/toUp.png" class="toUp" v-show="isShowToUp" v-on:click="clickToUp()">
        <ui-footer style="margin-top:80px;"></ui-footer>
    </div>
</template>
<style lang="scss" scoped>
    .train-main{
        width: 1120px;
        margin: 0 auto;
        margin-top: 20px;
        .train-tech{
            width: 100%;
            padding:30px 40px 40px;
            height: 456px;
            background: white;
            .train-head{
                overflow: hidden;
                .morebtn{
                    width:98px;
                    height:32px;
                    cursor:pointer;
                    background: url("./images/more.png");
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                }
                .morebtn:hover{
                    background: url("./images/moreHover.png");
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                }
            }
            .smallTech, .smallTechImg{
                width:220px;
                height: 150px;
                float: left;
                margin-left: 40px;
                margin-bottom:20px;
            }
            .smallTechImg{
                position:relative;
                img{
                    cursor:pointer;
                }
                div{
                    position:absolute;
                    width:100%;
                    bottom:0px;
                    height:40px;
                    font-size: 12px;
                    background:rgba(0, 0, 0, 0.38);
                    padding:13px 10px 12px;
                    color: #FFFFFF;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow:ellipsis;
                }
            }
        }
        .train-fund{
            width: 100%;
            padding:40px;
            height: 446px;
            background: white;
            margin-top: 20px;
            .train-head{
                overflow: hidden;
                .morebtn{
                    width:98px;
                    height:32px;
                    cursor:pointer;
                    background: url("./images/more.png");
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                }
                .morebtn:hover{
                    background: url("./images/moreHover.png");
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                }
            }
            .fund-main{
                padding: 0 60px;
                .fund-item{
                    float: left;
                    width: 220px;
                    height: 295px;
                    background: white;
                    margin-right: 130px;
                    border: 1px solid rgba(0,0,0,0.12);
                    .fund-head{
                        height: 170px;
                        .fund-title{
                            padding:15px 15px 40px;
                            width: 190px;
                            height: 60px;
                            font-size: 18px;
                            color: #666;
                            word-break:break-all;
                            display:-webkit-box;
                            -webkit-line-clamp:2;
                            -webkit-box-orient:vertical;
                            overflow:hidden;
                        }
                    }
                }
                .fund-item:hover{
                    box-shadow: 5px 5px 36px rgba(0, 0, 0, 0.08);
                }
                .fund-item:last-child{
                    margin-right: 0px;
                }
            }
        }
        .train-text{
            width:100%;
            margin-top: 20px;
            background: white;
            padding:24px 40px 40px;
            .train-head{
                overflow: hidden;
                .pagebtn{
                    width:62px;
                    height:62px;
                    cursor:pointer;
                    background: url("./images/page.png");
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                }
            }
            .course-part{
                width: 100%;
                border-bottom: 1px solid rgba(0,0,0,0.12);
                overflow: hidden;
                .course-item{
                    width: 230px;
                    float: left;
                    margin-right: 40px;
                    .course-head{
                        height: 40px;
                        position: relative;
                        .head-short{
                            width: 6px;
                            height: 1px;
                            position: absolute;
                            bottom:10px;
                            left: 0px;
                            background: #364983;
                        }
                        .head-img{
                            width: 28px;
                            height: 28px;
                            position: absolute;
                            left: 11px;
                            top:6px;
                        }
                        .head-line{
                            width: 118px;
                            height: 1px;
                            background: #364983;
                            position: absolute;
                            left: 0;
                            bottom: 0;
                        }
                    }
                    .course-main{
                        padding: 10px 11px;
                        .course-title{
                            color: #364983;
                            font-size: 18px;
                            margin-bottom: 15px;
                        }
                        .course-list{
                            height: 200px;
                            div{
                                font-size: 14px;
                                color: #666666;
                                width: 220px;
                                margin-bottom: 15px;
                                cursor: pointer;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow:ellipsis;
                            }
                        }
                        .more{
                            width: 100px;
                            height: 32px;
                            border: 1px solid #BC9B64;
                            border-radius: 20px;
                            text-align: center;
                            line-height: 30px;
                            color: #BC9B64;
                            font-size: 14px;
                            margin-bottom: 20px;
                            cursor: pointer;
                        }
                    }
                }
                .course-item:last-child{
                    margin-right: 0px;
                }
            }
        }
    }
    .toUp{
        width: auto;
        height: auto;
        position: fixed;
        bottom:244px;
        cursor: pointer;
    }
</style>
<script>
    import uiHeader from 'uiHeader';
    import uiFooter from 'uiFooter';
    import $ from "jquery";
    import png0 from './images/0.png';
    import png1 from './images/1.png';
    import png2 from './images/2.png';
    import png3 from './images/3.png';
    import png4 from './images/4.png';
    import png5 from './images/5.png';
    import png6 from './images/6.png';
    import png7 from './images/7.png';
    import api from 'train.server';
    import OnlineService from 'onlineService';

    module.exports = Vue.component('train-home',{
        data(){
            return{
                userInfo:window.PAGE_DATA.commonData.userInfo || {},
    			nav:      window.PAGE_DATA.commonData.nav       || [],
                userList: window.PAGE_DATA.commonData.toUcenter || [],
                loginUrl: window.PAGE_DATA.commonData.loginUrl || '',
                logoutUrl: window.PAGE_DATA.commonData.logoutUrl || '',
                registerUrl: window.PAGE_DATA.commonData.registerUrl || '',
                homeUrl:window.PAGE_DATA.commonData.homeUrl || '',
                ucenterUrl:window.PAGE_DATA.commonData.ucenterUrl || '',
                bigTechItem:{},
                otherTechItem:[],
                baseArr:[{}, {}, {}],
                firArr:[],
                secArr:[],
                firPng:[png0, png1, png2, png3],
                secPng:[png4, png5, png6, png7],
                isShowToUp:false,
            }
        },
        components:{
            OnlineService
        },
        methods:{
            techClick:function(){
                window.open(window.PAGE_DATA.webSite.videoTechMore)
            },
            clickDetail:function(url){
                window.open(url);
            },
            fundClick:function(){
                window.open(window.PAGE_DATA.webSite.videoBaseMore)
            },
            initCourses:function(){
                let _this = this;
                api.courses()
                .then(function(res){
                    if (res.data.header.code == 1){
                        _this.firArr = res.data.body.list.slice(0, 4);
                        _this.secArr = res.data.body.list.slice(4, 8);
                    }
                },function(res){

                })
            },
            clickToUp:function(){
                $('html, body').animate({
                    scrollTop: 0
                }, 500);
            }
        },
        mounted:function(){
            let _this = this;
            let tech = window.PAGE_DATA.webSite.videoTech;
            let tempArr = [{}, {}, {}, {}, {}];
            tech.forEach(function(val){
                tempArr[val.position - 1] = val;
            })
            this.bigTechItem = tempArr[0];
            this.otherTechItem = tempArr.slice(1, 5);
            let base = window.PAGE_DATA.webSite.videoBase;
            base.forEach(function(val){
                _this.baseArr[val.position - 1] = val;
            })
            this.initCourses();

            let left = ($(window).width() - 1120) / 2 + 1120 + 10;
            $(".toUp").css({
               left:left+"px"
            })
            $(window).scroll(function() {
                if ($(this).scrollTop() - $(window).height() > 0) {
                    _this.isShowToUp = true;
                    $(".toUp").css({
                        left:left+"px"
                    })
                } else {
                    _this.isShowToUp = false;
                }
            })
        }
    })
</script>



// WEBPACK FOOTER //
// src/components/train/view/home/home.vue